export var groupOfSiteIdValueGetter = function groupOfSiteIdValueGetter(props, groupOfSitesStore) {
  var gos = groupOfSitesStore.list.get(props.data[props.colDef.field]);

  if (gos) {
    return "".concat(gos.name, " (").concat(gos.externalId, ")");
  }

  return null;
};